// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"396":"2f180e0b","668":"e36fd462"}[chunkId] + ".chunk.css";
};